// App
import type React from 'react';
import { useSelector } from 'react-redux';

// Constellation
import { TextButton } from '@zillow/constellation';

// Components
import ResponsiveHeading from 'app/shared/StyledComponents/ResponsiveText';

// Misc / utils

// Types
import type { State } from 'app/shared/types/State';

type LinkType = {
  text: string | React.ReactNode;
  url: string;
  label: string;
};
const AreaLinks = () => {
  const area = useSelector((state: State) => state.address);

  const links: Array<LinkType> = [
    {
      text: (
        <>
          What is the Rent Zestimate<sup>®</sup>?
        </>
      ),
      url: 'https://www.zillow.com/rental-manager/resources/what-is-the-rent-zestimate/',
      label: 'WhatIsTheRentZestimate',
    },
    {
      text: 'Determining Rental Price Tutorial',
      url: 'https://www.zillow.com/rental-manager/resources/how-much-can-i-rent-my-house-for/',
      label: 'DeterminingRentalPriceTutorial',
    },
    {
      text: 'Guide to Raising Rent',
      url: 'https://www.zillow.com/rental-manager/resources/raising-rent/',
      label: 'GuideToRaisingRent',
    },
    {
      text: 'Collect Rent Online with Zillow',
      url: 'https://www.zillow.com/rental-manager/resources/collect-rent-online/',
      label: 'CollectRentOnlineWithZillow',
    },
    {
      text: 'Landlord Tools & Resources',
      url: 'https://www.zillow.com/rental-manager/resources/tools-forms/',
      label: 'LandlordToolsResources',
    },
  ];

  if (!area || !links) {
    return null;
  }
  const areaName = area.city && area.state && `${area.city}, ${area.state}`;

  return (
    <div>
      <ResponsiveHeading level="3" fontType="h3" marginBottom="md">
        Resources for Pricing and Renting your Property
      </ResponsiveHeading>
      {links.map((link, idx) => {
        return (
          <div key={`${areaName}-link-${link.url}-${idx}`}>
            <TextButton as="a" href={link.url} fontType="body" marginTop="sm" target="_blank">
              {link.text}
            </TextButton>
          </div>
        );
      })}
    </div>
  );
};

export default AreaLinks;
